module.exports = __webpack_public_path__ + "static/media/portrait-2.e51ddf37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portrait-2.jpg
// module id = 146
// module chunks = 0